import React, { useState } from 'react';
import Img1 from '../assets/img/footer_logo2.svg';
import Img2 from '../assets/img/footer_logo2.svg';
import Img3 from '../assets/img/footer_logo2.svg';
import Playbtn from '../assets/img/play.png';

import Video1 from '../assets/img/play.png';
import Video2 from '../assets/img/play.png';
import Video3 from '../assets/img/play.png';

import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import SeoHelmet from "../components/SeoHelmet";

const Courses = () => {
  const [activeVideo, setActiveVideo] = useState(null);

 
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: ""
  });

  const handleOpenModal = (videoSrc) => {
    setActiveVideo(videoSrc); // Set the active video source
  };

  const handleCloseModal = () => {
    setActiveVideo(null); // Clear the active video source
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

   

   const handleRazorpayPayment = async (courseType) => {
  if (!formData.name.trim()) {
    alert("Please enter your name.");
    return;
  }
  if (!formData.email.trim()) {
    alert("Please enter your email.");
    return;
  }
  if (!formData.phone.trim()) {
    alert("Please enter your phone number.");
    return;
  }

  const amount = courseType === "online" ? 50000 : courseType === "offline" ? 100000 : 200000;
  const description = courseType === "online" ? "Online Course" : courseType === "offline" ? "Offline Course" : "Only Offline Course";

  // 1. Create Razorpay Order from your PHP
  let orderId = null;
  try {
    const response = await fetch("https://thebhavanasingh.com/create_order.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount: amount * 100 }) // amount in paise
    });
    const data = await response.json();

    console.log("Create Order Response:", data);

    if (!data || !data.id) {
      alert("Failed to create Razorpay order.");
      return;
    }

    orderId = data.id;
  } catch (error) {
    console.error("Order creation error:", error);
    alert("Something went wrong while creating the order.");
    return;
  }

  // 2. Open Razorpay Checkout
  const options = {
    key: "rzp_live_meaLkJIwJaMl5q", // Your Razorpay Key ID
    amount: amount * 100,
    currency: "INR",
    name: "Bhavana Singh Courses",
    description: description,
    order_id: orderId, // ✅ VERY IMPORTANT
    prefill: {
      name: formData.name,
      email: formData.email,
      contact: formData.phone,
    },
    notes: {
      address: "Bhavana Singh",
    },
    theme: {
      color: "#3399cc",
    },
    handler: function (response) {
      console.log("Payment Success Response:", response);
      window.location.href = `/success?payment_id=${response.razorpay_payment_id}`;
    },
  };

  const razorpay = new window.Razorpay(options);

  razorpay.on("payment.failed", function (response) {
    console.error("Payment Failed:", response.error);
    alert(`Payment failed: ${response.error.description}`);
  });

  razorpay.open();
};




  return (
    <>
    <SeoHelmet />
      <section className="courses_head">
        <div className="container">
          <h2>UNLOCK YOUR BEST SELF</h2>
          <p>EXUDE LASTING CONFIDENCE & CHARISMA</p>
        </div>
      </section>

      <section className="transform trnscur">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <div className="courses_content">
                <h3>Transform With Bhavana – 2-Week Intensive Program Redefine Who You Are—Relaunch Where You’re Headed.</h3>
                <p>
                Led by renowned Personality & Image Transformation Coach Bhavana Singh, this premium 2-week offline course is a holistic program designed to help you step into your most confident, stylish, and impactful self.
                </p>
                <div className='pricebtgb'>
                  <span>Offline Only</span>
                  <p>INR 2,00,000</p>
                </div>
                <div className="btngro">
                  <a href="courses/3">
                    <span>Get Started</span>
                  </a>
                  <a href="#" data-bs-toggle="modal" data-bs-target="#offlineonlyCourseModal"><span>Enrol Now</span></a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="courses_image">
                <img src={Img3} alt="" width="100%" />
                <a
                  href="#"
                  onClick={() => handleOpenModal(Video3)}
                  data-bs-toggle="modal"
                  data-bs-target="#videoModal"
                >
                  <img src={Playbtn} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="transform">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <div className="courses_content">
                <h3>Transform with Bhavana | Offline course</h3>
                <p>
                  This immersive course is designed to guide you through every aspect of personality development—from mastering confident body language and public speaking to building rapport in client interactions. You’ll also refine your personal style, learning essential styling and makeup skills to carry yourself with poise and polish.
                </p>
                <div className='pricebtgb'>
                  <span>For Offline</span>
                  <p>INR 100,000 + GST</p>
                </div>
                <div className="btngro">
                  <a href="courses/2">
                    <span>Get Started</span>
                  </a>
                  <a href="#" data-bs-toggle="modal" data-bs-target="#offlineCourseModal"><span>Enrol Now</span></a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="courses_image">
                <img src={Img1} alt="" width="100%" />
                <a
                  href="#"
                  onClick={() => handleOpenModal(Video1)}
                  data-bs-toggle="modal"
                  data-bs-target="#videoModal"
                >
                  <img src={Playbtn} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="transform trnscur">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <div className="courses_content">
                <h3>TRANSFORM YOURSELF WITH Bhavana SINGH | ONLINE COURSE</h3>
                <p>
                This immersive course is designed to guide you through every aspect of personality development—from mastering confident body language and public speaking to building rapport in client interactions. You’ll also refine your personal style, learning essential styling and makeup skills to carry yourself with poise and polish.
                </p>
                <div className='pricebtgb'>
                  <span>For Online</span>
                  <p>INR 50,000 + GST</p>
                </div>
                <div className="btngro">
                  <a href="courses/1">
                    <span>Get Started</span>
                  </a>
                  <a href="#" data-bs-toggle="modal" data-bs-target="#onlineCourseModal"><span>Enrol Now</span></a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="courses_image">
                <img src={Img2} alt="" width="100%" />
                <a
                  href="#"
                  onClick={() => handleOpenModal(Video2)}
                  data-bs-toggle="modal"
                  data-bs-target="#videoModal"
                >
                  <img src={Playbtn} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      

     
      <div className="modal fade" id="offlineCourseModal" tabIndex="-1" aria-labelledby="offlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Offline Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("offline")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div className="modal fade" id="onlineCourseModal" tabIndex="-1" aria-labelledby="onlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Online Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("online")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div className="modal fade" id="offlineonlyCourseModal" tabIndex="-1" aria-labelledby="offlineonlyCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Only Offline Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("Only Offline Course")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
     
      <div
        className={`modal fade ${activeVideo ? "show" : ""}`}
        id="videoModal"
        tabIndex="-1"
        aria-labelledby="videoModalLabel"
        aria-hidden={!activeVideo}
        style={{ display: activeVideo ? "block" : "none" }}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) {
            handleCloseModal();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered video_sectio">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="videoModalLabel">
                Bhavana Singh
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {activeVideo && (
                <iframe
                  id="videoFrame"
                  width="100%"
                  height="500"
                  src={`${activeVideo}#t=0&autoplay=1`}
                  frameBorder="0"
                  allow="autoplay"
                  allowFullScreen
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Courses;
